import { render, staticRenderFns } from "./Economico.vue?vue&type=template&id=530f304c&"
import script from "./Economico.vue?vue&type=script&lang=js&"
export * from "./Economico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports